import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';

import styles from '../assets/ServiceLocation-actions.module.scss';
import DeleteServiceLocationAction from './DeleteServiceLocationAction';
import { IServiceLocation } from 'src/types/service-locations';

const ServiceLocationActionsColumn: React.FunctionComponent<CellProps<IServiceLocation>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IServiceLocation>) => (
    <div className={classNames(styles.actions)}>
        <Link to={Router.generate(routes.SERVICE_LOCATION_EDIT, { id: original.id })} className="btn btn-info">
            <FontAwesomeIcon icon={faPencilAlt} />
        </Link>
        <DeleteServiceLocationAction data={original} />
    </div>
);

export default ServiceLocationActionsColumn;
